import React, { useState, useEffect } from 'react';
import { Activity, Users, CheckSquare, FileText, Clock, Loader2 } from 'lucide-react';
import { apiRequest } from '../../lib/utils';

export default function SystemStatsWidget() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchSystemStats();
  }, []);

  const fetchSystemStats = async () => {
    try {
      const data = await apiRequest('/dashboard/admin-stats');
      setStats(data);
    } catch (error) {
      console.error('Failed to load system stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-slate-200 p-4 h-full">
        <div className="flex items-center justify-center h-32">
          <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
        </div>
      </div>
    );
  }

  const statItems = [
    { icon: Users, label: 'Total Staff', value: stats?.total_users || 0, color: 'text-blue-600', bg: 'bg-blue-50' },
    { icon: CheckSquare, label: 'Active Tasks', value: stats?.active_tasks || 0, color: 'text-green-600', bg: 'bg-green-50' },
    { icon: FileText, label: 'Daily Reports', value: stats?.daily_reports_today || 0, color: 'text-amber-600', bg: 'bg-amber-50' },
    { icon: Clock, label: 'Clocked In', value: stats?.clocked_in || 0, color: 'text-purple-600', bg: 'bg-purple-50' },
  ];

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-4 h-full" data-testid="system-stats-widget">
      <div className="flex items-center gap-2 mb-4">
        <Activity className="h-5 w-5 text-slate-600" />
        <h3 className="font-semibold text-slate-900">System Overview</h3>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {statItems.map((item, index) => (
          <div key={index} className={`p-3 ${item.bg} rounded-lg`}>
            <div className="flex items-center gap-2 mb-1">
              <item.icon className={`h-4 w-4 ${item.color}`} />
              <span className="text-xs text-slate-600">{item.label}</span>
            </div>
            <div className={`text-xl font-bold ${item.color}`}>{item.value}</div>
          </div>
        ))}
      </div>

      {stats?.last_updated && (
        <div className="mt-3 text-xs text-slate-400 text-center">
          Updated {new Date(stats.last_updated).toLocaleTimeString()}
        </div>
      )}
    </div>
  );
}
